import { FormattedMessage, IntlShape, useIntl } from 'react-intl';
import moment from 'moment';
import { z } from 'zod';
import formMessages from '~/components/form-messages';
import Spacings from '~/modules/ui-kit/spacings';
import messages from './messages';
import { useAppForm } from '../Form';

const schema = (intl: IntlShape) =>
  z
    .object({
      from: z
        .string({
          error: intl.formatMessage(formMessages.required),
        })
        .min(1, intl.formatMessage(formMessages.required)),
      to: z
        .string({
          error: intl.formatMessage(formMessages.required),
        })
        .min(1, intl.formatMessage(formMessages.required)),
    })
    .superRefine((value, ctx) => {
      if (value.from && moment(value.from).isBefore(moment(), 'day')) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: intl.formatMessage(messages.startMustNotBeInThePast),
          path: ['from'],
        });
      }

      if (value.from && value.to && value.from > value.to) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: intl.formatMessage(messages.endMustNotBeforeBegin),
          path: ['to'],
        });
      }
    });

type AbsenceFormProps = {
  onSubmit: (values: { from: string; to: string }) => unknown;
};

const AbsenceForm = (props: AbsenceFormProps) => {
  const intl = useIntl();
  const form = useAppForm({
    defaultValues: {
      from: '',
      to: '',
    },
    validators: {
      onChange: schema(intl),
    },
    onSubmit({ value }) {
      props.onSubmit(value);
    },
  });

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        form.handleSubmit();
      }}
    >
      <Spacings.Inset>
        <Spacings.Stack scale="l">
          <form.AppField name="from">
            {(field) => (
              <field.DateField
                label={<FormattedMessage {...messages.absenceBegin} />}
              />
            )}
          </form.AppField>
          <form.AppField name="to">
            {(field) => (
              <field.DateField
                label={<FormattedMessage {...messages.absenceEnd} />}
              />
            )}
          </form.AppField>
          <div>
            <form.AppForm>
              <form.SubmitButton>
                <FormattedMessage {...messages.saveAbsence} />
              </form.SubmitButton>
            </form.AppForm>
          </div>
        </Spacings.Stack>
      </Spacings.Inset>
    </form>
  );
};

export default AbsenceForm;
